import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../hooks/use-auth";
import axios from "axios";
import { useModal } from "react-hooks-use-modal";
import {
  FormLabel,
  FormInput,
  FormLabelInputWrapper,
  ModalStyle,
  ModalTitle,
  ModalClose,
  SubmitPerformanceSpan,
  SubmitPerformanceButton,
  ModalForm,
} from "styles/styles";

// Define the parent array as provided
const parentArray = [
  { title: "工程名", field: "process_name", required: true },
  { title: "設備名", field: "equipment_name", required: true },
  {
    title: "担当者ID",
    field: "charged_user_display_id",
    required: true,
  },
  {
    title: "担当者名",
    field: "charged_user_name",
    required: true,
  },
  {
    title: "作業区分",
    field: "working_process_list_name",
    required: true,
  },
  {
    title: "完了数",
    field: "complete_number",
    required: true,
  },
  { title: "不良数", field: "defective_number" },
  {
    title: "不良区分",
    field: "defective_list_name",
  },
  {
    title: "実績加工時間(分)",
    field: "cycle_time",
    required: true,
  },
  {
    title: "作業した日付",
    field: "worked_date",
    required: true,
  },
  { title: "メモ", field: "memo" },
];

const AppearPerformances = ({
  processId,
  processName,
  equipmentName,
  close,
  type,
}: any) => {
  const [latestData, setLatestData] = useState<any>(null);
  const auth = useAuth();
  const [Modal, open, modalClose] = useModal("root", { preventScroll: true });
  const modalStyleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fetchLatestData = async () => {
      try {
        const result: any = await axios.get(
          `/v0/records-processes/${processId}/records-performances`,
          {
            headers: auth.authorizationHeader,
            params: {
              factory_id: auth.factoryId,
            },
          }
        );
        console.log(processId);
        console.log(result.data);
        if (result.data && result.data.length > 0) {
          const completeRecords = result.data.filter(
            (record: any) =>
              record.working_process_list_display_id === "complete"
          );
          if (completeRecords.length > 0) {
            const latest = completeRecords.reduce((prev: any, current: any) =>
              new Date(prev.worked_date) > new Date(current.worked_date)
                ? prev
                : current
            );
            setLatestData(latest);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchLatestData();
  }, [auth, processId]);

  if (!latestData) {
    return <p>Loading...</p>;
  }

  console.log("Latest Data:", latestData);
  const formattedDate = latestData.worked_date ? latestData.worked_date : "N/A";

  const listItems = parentArray.map((item, index) => {
    const { field, title, required } = item;
    const value =
      field === "process_name"
        ? processName
        : field === "equipment_name"
        ? equipmentName
        : latestData[field] !== undefined
        ? latestData[field]
        : "";
    const displayLabel = title.trim() !== "" ? title : field;
    return (
      <FormLabelInputWrapper key={index}>
        <FormLabel htmlFor={field}>
          {required && <span style={{ color: "red" }}>*</span>}
          {displayLabel}
        </FormLabel>
        <FormInput id={field} value={value} disabled />
      </FormLabelInputWrapper>
    );
  });

  const handleOpen = () => {
    open();
    setTimeout(() => {
      if (modalStyleRef.current) {
        modalStyleRef.current.scrollTo({ top: 0, behavior: "auto" });
      }
    }, 50);
  };

  return (
    <>
      {type === "button" ? (
        <SubmitPerformanceButton onClick={handleOpen}>
          {formattedDate}
        </SubmitPerformanceButton>
      ) : type === "span" ? (
        <SubmitPerformanceSpan onClick={handleOpen}>
          {formattedDate}
        </SubmitPerformanceSpan>
      ) : null}
      <Modal>
        <ModalStyle ref={modalStyleRef}>
          <ModalTitle>最新の実績データ</ModalTitle>
          <ModalForm style={{ width: "500px" }}>{listItems}</ModalForm>
          <ModalClose
            onClick={() => {
              modalClose();
              if (close) close();
            }}
          >
            CLOSE
          </ModalClose>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default AppearPerformances;
